import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "pl-3 font-bold text-xl" }, "Core Values", -1)
const _hoisted_2 = { class: "shadow-base rounded-3xl w-[18rem] my-2 mx-2" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "font-bold flex text-left pl-10 mt-2" }
const _hoisted_5 = ["innerHTML"]

import { IonSlides, IonSlide } from "@ionic/vue"

  interface Details {
    image: string
    label: string
    description: string
  }

  interface Props {
    coreData: Details[]
    brandColor?: string
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CoreValue',
  props: {
    coreData: {},
    brandColor: {}
  },
  setup(__props: any) {

const props = __props;

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createVNode(_unref(IonSlides), null, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.coreData, (core) => {
          return (_openBlock(), _createBlock(_unref(IonSlide), {
            key: `${core}_id`
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", {
                  class: "flex justify-center items-center h-[170px] rounded-t-3xl",
                  style: _normalizeStyle({
              'background-color': _ctx.brandColor && !core.image ? _ctx.brandColor : '#FAFAFD',
            })
                }, [
                  (core.image)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: core.image,
                        alt: ""
                      }, null, 8, _hoisted_3))
                    : (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: "text-center text-[100px] font-bold",
                        style: _normalizeStyle({ color: _ctx.brandColor ? 'white' : 'black' })
                      }, _toDisplayString(core.label[0]), 5))
                ], 4),
                _createElementVNode("span", _hoisted_4, _toDisplayString(core.label), 1),
                _createElementVNode("p", {
                  class: "font-normal text-sm opacity-70 text-left pl-10 pb-10",
                  innerHTML: core.description
                }, null, 8, _hoisted_5)
              ])
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    })
  ]))
}
}

})